/**
 * Регулярка для проверки на логин
 *
 * Пропускает все цифры, англоязычные буквы разного регистра и символы:
 * (пробел) _
 *
 * Длина от 4 до 24 символов
 */
export const regExpUsername = new RegExp(/^[\w.]{4,24}$/);

/**
 * Регулярка для проверки на емейл (аналогичная используется на бэке)
 *
 * Все эти валидные адреса проходят регулярку
 * mkyong@yahoo.com, mkyong-100@yahoo.com, mkyong.100@yahoo.com, mkyong111@mkyong.com, mkyong-100@mkyong.net,
 * mkyong.100@mkyong.com.au, mkyong@1.com, mkyong@gmail.com.com, mkyong+100@gmail.com, mkyong-100@yahoo-test.com
 *
 * Невалидные адреса которые пройдут
 * mkyong..2002@gmail.com, mkyong@mkyong@gmail.com, mkyong@gmail.com.1a, .mkyong@mkyong.com
 *
 * @type {RegExp}
 */
export const regExpEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/**
 * Регулярка для WMZ
 *
 * @type {RegExp}
 */
export const regExpWMZ = new RegExp(/[A-Z][0-9]{12}$/);

/**
 * Регулярка для USDT
 *
 * @type {RegExp}
 */
export const regExpUSDT = new RegExp(/^[\w\d]{34}$/);

/**
 * Регулярка для USDT (BEP20)
 *
 * @type {RegExp}
 */
export const regExpUSDTBEP20 = new RegExp(/^0x[a-fA-F0-9]{40}$/);

/**
 * Регулярка для Capitalist
 *
 * @type {RegExp}
 */
export const regExpCapitalist = new RegExp(/[A-Z][0-9]{8}$/);

/**
 * Регулярка для id продукта из slug
 * Для поиска в урле можно использовать что-то вроде (\d+?)(?=\/|\?|$) (требует доработки)
 *
 * @type {RegExp}
 */
export const regExpProductIdFromSlug = new RegExp(/(\d+?)(?=\/|\?|$)/);

/**
 * Регулярка для валидации title_slug
 *
 * @type {RegExp}
 */
export const regExpSlug = new RegExp(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);

/**
 * Регулярка для паролей (аналогичная используется на бэке)
 *
 * Пропускает все цифры, англоязычные буквы разного регистра и символы:
 * (пробел) ! " # $ % & ' ( ) * + , - . / : ; < = > ? @ [ \ ] ^ _` { | } ~
 *
 * Проверки на длину тут нет! Делается отдельно в коде для вывода более user friendly ошибок
 */
export const regExpPassword = new RegExp(/^[0-9a-zA-Z !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/);

/**
 * Регулярка для телеграма
 *
 * @что-душе-угодно
 */
export const regExpTelegram = new RegExp(/^(\w{1,23})$/);

/**
 * Регулярка для дискорда
 *
 * что-душе-угодно#1234
 * или
 * lowercase.123.with_some.symbols_allowed
 *
 * @type {RegExp}
 */
// export const regExpDiscord = new RegExp(/^(.+#\d{4})$/);
export const regExpDiscord = new RegExp(/^((.+#\d{4})|(?!.*\.\.)[a-z0-9._]{2,32})$/);

/**
 * Регулярка для номера карты
 *
 * 16 цифр
 */
export const regExpCardNumber = new RegExp(/^[0-9]{16}$/);

/**
 * Регулярка для бекапов фифы
 *
 * 8 цифр
 */
export const regExpFifaBackup = new RegExp(/^[0-9]{8}$/);

/**
 * Регулярка для срока действия карты
 *
 * MM/YY
 */
export const regExpExpDate = new RegExp(/^[0-1][0-9]\/[0-9]{2}$/);

/**
 * Регулярка для даты рождения
 *
 * MM/DD/YY
 */
export const regExpBirthday = new RegExp(/^[0-1][0-9]\/[0-3][0-9]\/[0-9]{2}$/);

/**
 * Регулярка для имени
 *
 * Английские буквы разного регистра длинной от 2 до 24
 */
export const regExpName = new RegExp(/^[a-zA-Z]{2,24}$/);

/**
 * Регулярка для URL
 */
// eslint-disable-next-line max-len
export const urlRegexp = new RegExp(/https?:\/\/(www\.)?([-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}|localhost)\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/);

/**
 * Регулярка для провеки строки на соответствие числу с максимум двумя знаками после запятой
 */
export const regExpTwoDigitsAfterComma = new RegExp(/^\d*(.|,)?(\d{0,2})$/);

/**
 * Регулярка для проверки VISA
 */
export const regExpVisaCard = new RegExp(/^4[0-9]{6,}$/);

/**
 * Регулярка для проверки MASTERCARD
 */
// eslint-disable-next-line max-len
export const regExpMastercardCard = new RegExp(/^5[1-5][0-9]{14}|^(222[1-9]|22[3-9]\\d|2[3-6]\\d{2}|27[0-1]\\d|2720)[0-9]{12}$/);

/**
 * Регулярка для номера карты МИР
 */
export const regExpMirCardNumber = new RegExp(/^220[0-4]\d{6,}$/);

/**
 * Регулярка для проверки КИРИЛЛИЦЫ в строке
 *
 * Кириллица, все регистры
 */
export const regExpCyrillic = new RegExp(/[а-яёА-ЯЁ]+/g);

/**
 * Регулярка для проверки Card Holder (латиница + символы) в строке
 */
export const regExpCardHolder = new RegExp(/[^a-zA-Z'`~\-.\s]+/g);

/**
 * Регулярка для простой проверки Battle Tag (COD MW)
 */
export const regExpBattleTag = new RegExp(/^\D.+#\d{4}/gsi);

/**
 * Регулярка для проверки raider.io (WoW)
 */
export const regExpRaiderIoLink = new RegExp(/(http)?(s)?(:\/\/)?(www.)?raider.io\/(.{3,})/gsi);

/**
 * Регулярка для проверки raider.io (WoW)
 */
export const regExpDestinyTrackerLink = new RegExp(/(http)?(s)?(:\/\/)?(www.)?destinytracker.com\/(.{3,})/gsi);

/**
 * Регулярка для проверки wowhead (WoW)
 */
// eslint-disable-next-line max-len
export const regExpWowHeadLink = new RegExp(/(href="https?:\/\/([\w]+).wowhead\.com\/([\w]+=[0-9]+)(\/.+?)?")/gmi);

/**
 * Регулярка для проверки light.gg (Destiny)
 */
export const regExpLightGGLink = new RegExp(/((https?:.+?light\.gg\/.+?\/)(hover\/)?([0-9]+)(.+?))"/gmi);

/**
 * Регулярка для проверки на отсутствие спецсимволов и цифр в непустой строке
 */
export const regExpExcludeDigitsSpecials = new RegExp(/^[^\\/'*~\-“`"№!@#$%^&()_+={}[\]|:;’<,>.?๐฿\d\s]+$/gsi);

/**
 * Регулярка для проверки опций в продукте по слову selfplay
 */
export const regExpSelfplay = new RegExp(/self[\s-]?play/i);

/**
 * Регулярка для нахождения ссылки для апсейла (MVP)
 */
// eslint-disable-next-line max-len
export const regUpsaleLink = new RegExp(/((http|https):\/\/skycoach\.gg\/[A-Za-z0-9/-]+)(?<ref>\?upsale_ref=[A-Za-z0-9]+)/g);

/**
 * Регулярка для нахождения ссылки для апсейла для ПРО (MVP)
 */
// eslint-disable-next-line max-len
export const regUpsaleProLink = new RegExp(/((http|https):\/\/skycoach\.gg\/[A-Za-z0-9/-]+)(?<ref>\?upsale_ref=[A-Za-z0-9]+)?/g);

/**
 * Регулярка для нахождения ссылок на товары (MVP)
 */
export const regExpProductLink = new RegExp(/(http|https):\/\/skycoach\.gg\/[A-Za-z0-9/-]+/gm);
/**
 * Регулярка для поиска ссылки на трастпилот
 */
export const trustpilotLink = new RegExp(/(((http|https):|)\/\/(www.|)|)trustpilot\.com\/[.?=&A-Za-z0-9/-]+/gm);
